import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TimePicker from 'src/components/Pickers/Time';
import DayPicker from 'src/components/Pickers/Day';
import PercentagePicker from 'src/components/Pickers/Percentage';
import SubscriptionTypeUpgrade from 'src/components/SubscriptionTypeUpgrade';
export default {
  components: {
    TimePicker: TimePicker,
    DayPicker: DayPicker,
    PercentagePicker: PercentagePicker,
    SubscriptionTypeUpgrade: SubscriptionTypeUpgrade
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    mode: {
      type: String,
      default: 'user',
      validator: function validator(value) {
        return ['user', 'account'].indexOf(value) !== -1;
      }
    }
  },
  computed: {
    hasReminderFeature: function hasReminderFeature() {
      return this.me.account.hasFeatureAccess('reminders_team');
    }
  },
  data: function data() {
    return {
      cadenceOption: [{
        label: this.$t('timeframe.daily'),
        value: 'daily'
      }, {
        label: this.$t('timeframe.weekly'),
        value: 'weekly'
      }, {
        label: this.$t('timeframe.monthly'),
        value: 'monthly'
      }]
    };
  },
  methods: {
    emitInput: function emitInput(changedProperty, newValue) {
      this.$emit('input', _objectSpread(_objectSpread({}, this.value), {}, _defineProperty({}, changedProperty, newValue)));
    }
  }
};